"use strict";
/* global setSoftwareHiddenValues */
/* global debounce */
var novicell = novicell || {};

novicell.addRemoveButtons =
    novicell.addRemoveButtons ||
    (function() {
        var outerAddRemoveCountainer =
            "m-amountInputArrows:not(.m-amountInputArrows--disabled)";
        var commonAddRemoveButtonsClass = "m-amountInputArrows__button";
        var commonAmountInputsClass = "m-amountInputArrows__input";
        var buttonsPlusClass = "m-amountInputArrows__button--up";
        var buttonsMinusClass = "m-amountInputArrows__button--down";
        var buttonModifierProductDetail =
            "m-amountInputArrows__button--prodDetailJs"; //software
        var buttonModifierStandardProductDetail =
            "m-amountInputArrows__button--prodDetailStdJs"; //training and hardware

        function init() {
            var addRemoveButtons = document.querySelectorAll(
                "." +
                    outerAddRemoveCountainer +
                    " ." +
                    commonAddRemoveButtonsClass
            );
            if (addRemoveButtons.length) {
                for (var i = 0; i < addRemoveButtons.length; i++) {
                    addRemoveButtons[i].addEventListener(
                        "click",
                        addRemoveOnEvent
                    );
                }
            }
            var inputs = document.querySelectorAll(
                "." + commonAmountInputsClass
            );
            if (inputs.length) {
                for (var j = 0; j < inputs.length; j++) {
                    inputs[j].addEventListener("input", addRemoveOnEvent);
                    inputs[j].addEventListener(
                        "keydown",
                        function(k) {
                            if (k.code.includes("Enter")) {
                                k.preventDefault();
                                k.stopPropagation();
                                k.returnValue = false;
                                return false;
                            }
                            debounce(this, setSoftwareHiddenValues);
                        },
                        false
                    );
                }
            }
        }
        function addRemoveOnEvent() {
            var numberField = this;
            if (this.classList.contains(commonAddRemoveButtonsClass)) {
                numberField = this.parentNode.children[0];
                increaseOrDecrease(this, numberField);
            }
            if (
                this.classList.contains(buttonModifierProductDetail) ||
                this.classList.contains(buttonModifierStandardProductDetail)
            ) {
                var input = this.parentNode.querySelector("input");
                var event = new CustomEvent("change");
                input.dispatchEvent(event);
            }
        }
        function increaseOrDecrease(el, numberField) {
            if (el.classList.contains(buttonsPlusClass)) {
                increase(numberField);
            } else if (el.classList.contains(buttonsMinusClass)) {
                decrease(numberField);
            }
        }
        function increase(numberField) {
            var currentValue = parseInt(numberField.value, 10);
            currentValue = isNaN(currentValue) ? 1 : currentValue;
            var newValue = ++currentValue;
            numberField.value = newValue;
        }

        function decrease(numberField) {
            var currentValue = parseInt(numberField.value, 10);
            currentValue = isNaN(currentValue) ? 1 : currentValue;
            if (currentValue > 1) {
                var newValue = --currentValue;
                numberField.value = newValue;
            }
        }

        return {
            init: init
        };
    })();
